import {NgForm} from '@angular/forms';
import {Component, OnInit} from '@angular/core';
import {DeviceService} from '../../../shared/services/device/device.service';
import {ModalService} from '../../../shared/services/modal/modal.service';
import {LevelService} from '../../../shared/services/level/level.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {ReferentialService} from '../../../shared/services/referential/referential.service';
import {forkJoin} from 'rxjs';
import {map} from 'rxjs/operators';
import {faSearch} from '@fortawesome/free-solid-svg-icons/faSearch';
import {Device} from '../../../shared/classes/device/device';

@Component({
  selector: 'app-device-finder',
  templateUrl: './device-finder.component.html',
  styleUrls: ['./device-finder.component.css']
})
export class DeviceFinderComponent implements OnInit {

  public deviceSearched: any;
  public deviceLevelName: string;
  public deviceLevel: any;
  public showTable = false;
  public showSpinner = false;
  public deviceTypes: [];
  public unitList: any;
  public faSearch = faSearch;
  public deviceLocationName: string;
  public deviceProjectName: string;


  constructor(private modalService: ModalService,
              private deviceService: DeviceService,
              private levelService: LevelService,
              private toastr: ToastrService,
              private translate: TranslateService,
              private referentialService: ReferentialService) {
  }

  ngOnInit() {
    this.showTable = false;
    forkJoin(
      this.referentialService.getDeviceTypes().pipe(map((data: any) => {
          data.forEach((d) => {
            d.value = d.id;
            delete d.id;
            d.name = d.type;
            delete d.type;
          });
          return data;
        })
      ),
      this.referentialService.getUnits(),
    ).subscribe((results) => {

      this.deviceTypes = results[0];
      this.unitList = results[1];
    });
  }

  open(modal) {
    this.modalService.openNgbModal(modal, {size: 'lg'});
  }

  onSubmit(form: NgForm) {
    this.showSpinner = true;
    this.deviceService.getDeviceViaUID(form.value.deviceUID).subscribe(
      (device: Device) => {
        this.deviceSearched = device;
        this.deviceProjectName = '-';
        this.deviceLocationName = '-';
        if (device.project_device_location !== false) {
          this.deviceLocationName = device.project_device_location.name;
          this.deviceProjectName = device.project_device_location.project.name;
        }
        if (device.project_device_assignement !== false) {
          this.deviceLocationName = device.project_device_assignement.name;
          this.deviceProjectName = device.project_device_assignement.project.name;
        }
          this.levelService.getLevel(this.deviceSearched.level.id).subscribe(
          (level) => {
            this.deviceLevel = level;
            this.deviceLevelName = this.deviceLevel.name;
            this.showTable = true;
            this.showSpinner = false;
          }
        );
      }, error => {
        this.toastr.error(this.translate.instant('PLEASE_VALID_UID'));
        this.showSpinner = false;
      }
    );
  }
}
